import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Role } from 'src/app/models';
import { AuthGuard } from 'src/app/services/auth/auth-guard';
import { ItauDashboardComponent } from './itau-dashboard/itau-dashboard.component';
import { SchedulerJobsComponent } from './scheduler-jobs/scheduler-jobs.component';
import { TaxPriceComponent } from './tax-price/tax-price.component';

const routes: Routes = [
  { path: 'tax-price', component: TaxPriceComponent },
  {
    path: 'itau-dashboard',
    component: ItauDashboardComponent,
    canActivate: [
      () =>
        inject(AuthGuard).canActivate() &&
        inject(AuthGuard).canActivatePermissions([Role.Full_Administrator])
    ]
  },
  {
    path: 'scheduler-jobs',
    component: SchedulerJobsComponent,
    canActivate: [
      () =>
        inject(AuthGuard).canActivate() &&
        inject(AuthGuard).canActivatePermissions([Role.Full_Administrator])
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FinancialRoutingModule {}
